module.exports = __webpack_public_path__ + "img/Photo-Editing.108ff1b0.jpg";